import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-white/10 last:border-0" data-id="element-164">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none" onClick={onClick} data-id="element-165">
        <span className="font-bold text-lg text-white pr-8" data-id="element-166">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-brand-green" data-id="element-167">
          <ChevronDown size={24} data-id="element-168" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-169">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-170">
            <div className="pb-6 text-white/70 leading-relaxed" data-id="element-171">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: React.ReactNode;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto bg-white/5 rounded-2xl border border-white/10 p-6 md:p-8" data-id="element-172">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-173" />)}
    </div>;
}